/**
 * Optivise Energy — Header Script
 * Mobile nav toggle, sticky header scroll behavior
 */

document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('site-header');
  const toggle = document.getElementById('menu-toggle');
  const nav = document.getElementById('site-navigation');
  const overlay = document.getElementById('menu-overlay');

  if (!header || !toggle || !nav) return;

  // Mobile nav toggle
  const toggleMenu = () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isOpen);
    nav.classList.toggle('is-open');
    overlay?.classList.toggle('is-active');
    document.body.style.overflow = isOpen ? '' : 'hidden';
  };

  toggle.addEventListener('click', toggleMenu);
  overlay?.addEventListener('click', toggleMenu);

  // Close on nav link click (mobile)
  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      if (nav.classList.contains('is-open')) {
        toggleMenu();
      }
    });
  });

  // Sticky header scroll effect
  let lastScroll = 0;

  const handleScroll = () => {
    const currentScroll = window.scrollY;

    if (currentScroll > 10) {
      header.classList.add('site-header--scrolled');
    } else {
      header.classList.remove('site-header--scrolled');
    }

    lastScroll = currentScroll;
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // Close mobile menu on resize to desktop
  const mediaQuery = window.matchMedia('(min-width: 1025px)');
  mediaQuery.addEventListener('change', (e) => {
    if (e.matches && nav.classList.contains('is-open')) {
      toggleMenu();
    }
  });
});
